import { render } from "./Header.vue?vue&type=template&id=20dd9240&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=20dd9240&lang=scss"
import "./Header.vue?vue&type=style&index=1&id=20dd9240&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3619508726/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20dd9240"]])

export default __exports__